import Vue, { DirectiveOptions } from "vue";
import "normalize.css";
import ElementUI from "element-ui";
import "@/styles/element-variables.scss";
import "@/styles/index.scss";
import App from "@/App.vue";
import store from "@/store";
import { AppModule } from "@/store/modules/app";
import router from "@/router";
import "@/icons/components";
import "@/permission";
import SvgIcon from "vue-svgicon";
import * as directives from "@/directives";
import * as filters from "@/filters";
import i18n from "@/lang";
import Print from "vue-print-nb";
import VueClipboard from "vue-clipboard2";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import PublicComponent from "@/components/componentInstall";
// import "./utils/update"

ElementUI.Dialog["props"].closeOnClickModal.default = false;
Vue.use(ElementUI, {
  size: AppModule.size, // Set element-ui default size
  i18n: (key: string, value: string) => i18n.t(key, value),
});

Vue.use(SvgIcon, {
  tagName: "svg-icon",
  defaultWidth: "1em",
  defaultHeight: "1em",
});
Vue.use(VXETable);
Vue.use(Print);
Vue.use(PublicComponent);
Vue.use(VueClipboard);
// Register global directives
Object.keys(directives).forEach((key) => {
  Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key]);
});

// Register global filter functions
Object.keys(filters).forEach((key) => {
  Vue.filter(key, (filters as { [key: string]: Function })[key]);
});

Vue.config.productionTip = false;

Vue.directive("has", {
  inserted: function (el, binding, node) {
    const value = binding.value;
    const self = node.context;
    if (
      self.$route.meta.buttonCodes &&
      Array.isArray(self.$route.meta.buttonCodes)
    ) {
      if (!self.$route.meta.buttonCodes.includes(value)) {
        el.parentNode.removeChild(el);
      }
    }
  },
});
Vue.directive("stop", {
  inserted: function (el, binding, vnode) {
    const value = binding.value;
    const self = vnode.context;
    if (
      self.$route.meta.buttonCodes &&
      Array.isArray(self.$route.meta.buttonCodes)
    ) {
      if (!self.$route.meta.buttonCodes.includes(value)) {
        el.classList.add("is-disabled");
      }
    }
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
